// RUTA SECRETA del modo demo.
//
// La demostración NO se sirve en la raíz: vive bajo un prefijo aleatorio (p. ej. `/8dh39pgq5qm`).
// Cualquier otra dirección responde un 404 pelado, sin pistas de que exista algo detrás.
//
// El código se resuelve en dos capas, en este orden:
//   1. `window.__DEMO_RUTA__` — lo escribe el archivo suelto `demo-ruta.js` del build.
//      ROTAR EL CÓDIGO = editar ese archivo de texto. NO hay que recompilar.
//   2. `process.env.REACT_APP_DEMO_RUTA` — horneado en el build desde `DEMO_RUTA` (.env.demo).
//      Es solo el respaldo por si el archivo suelto no cargara.
//
// En producción (`REACT_APP_DEMO_MODE` ausente) este módulo queda inerte: nadie lo consulta.
const PATRON = /^[A-Za-z0-9]{10,16}$/;

const enVentana = typeof window !== "undefined" ? window.__DEMO_RUTA__ : "";
const horneada = process.env.REACT_APP_DEMO_RUTA;
const cruda = String(enVentana || horneada || "").replace(/^\/+|\/+$/g, "");

export const RUTA_DEMO = PATRON.test(cruda) ? cruda : "";
export const PREFIJO_DEMO = RUTA_DEMO ? `/${RUTA_DEMO}` : "";

// Sin código válido configurado no se autoriza NADA (ni la raíz): el demo queda cerrado.
export function rutaAutorizada(pathname) {
  if (!RUTA_DEMO) return false;
  const p = pathname || "/";
  return p === PREFIJO_DEMO || p.startsWith(`${PREFIJO_DEMO}/`);
}
